exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TopLeft-module__wrapper___3uOaB h1{font-size:22px}@media screen and (min-width:768px){.TopLeft-module__wrapper___3uOaB h1{font-size:28px}}.TopLeft-module__wrapper___3uOaB p{font-size:14px;color:#b4bac3}.TopLeft-module__wrapper___3uOaB svg{color:#0827e9}", ""]);

// exports
exports.locals = {
	"wrapper": "TopLeft-module__wrapper___3uOaB"
};